<template>
  <div>
    <div class="" v-for="node in treeData" :key="node.id">
      <div v-if="node.nodeType == 'floder1'">
        <div
          class="title"
          v-if="
            node.children &&
            node.children.length &&
            node.children[0].nodeType != 'floder1'
          "
        >
          {{ node.showName }}
        </div>
        <treeNode
          v-if="node.children && node.children.length"
          :treeData="node.children"
        ></treeNode>
      </div>
      <div class="cellTitle" v-if="node.nodeType == 'floder2'">
        <div class="name">
          <div class="txt">{{ node.showName }}</div>
          <el-button
            @click="detail(node)"
            type="primary"
            size="mini"
            icon="el-icon-more"
            >详细数据</el-button
          >
        </div>
        <treeNode
          v-if="node.children && node.children.length"
          :treeData="node.children"
        ></treeNode>
      </div>
      <div class="cellList" v-if="node.nodeType == 'index'">
        <div class="descriptions">
          <div class="descriptionsTitle">
            <div class="text">
              <strong>{{ node.showName }}</strong>
              <span v-if="node.unit">{{ node.unit }}</span>
            </div>
          </div>
          
          <div class="descriptionsContent">
            {{ node.value || "--" }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <li v-for="node in treeData" :key="node.id">
      <div v-if="node.nodeType == 'floder1'">
        <div v-if="node.children && node.children.length && node.children[0].nodeType != 'floder1'">{{ node.showName
          }}-{{ node.nodeType }}</div>
        <tree-node v-if="node.children && node.children.length" :treeData="node.children"></tree-node>
      </div>
      <div v-if="node.nodeType == 'floder2'">
        {{ node.showName }}-{{ node.nodeType }}
        <tree-node v-if="node.children && node.children.length" :treeData="node.children"></tree-node>
      </div>
      <div v-if="node.nodeType == 'index'">
        {{ node.showName }}-{{ node.nodeType }}
        <tree-node v-if="node.children && node.children.length" :treeData="node.children"></tree-node>
      </div>
    </li> -->
</template>

<script>
import { EventBus } from "./medicalBus.js";
export default {
  name: "TreeNode",
  props: {
    treeData: Array,
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    detail(node) {
      EventBus.$emit("TreeOne_node", node);
      // this.$emit('childNode', data)
      // this.$emit('child_visible', true)
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  color: #fff;
  margin-top: 5px;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 50px;

  &::before {
    content: "";
    width: 4px;
    height: 18px;
    background-color: #40a1ff;
    display: inline-block;
    margin-right: 5px;
  }
}

.cellTitle {
  width: 100%;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  .name {
    font-weight: bold;
    font-size: 15px;
    color: #999;
    display: flex;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 8px;
    width: 100%;
    justify-content: space-between;
    .txt{
      &::before {
        content: "";
        width: 7px;
        height: 7px;
        border-radius: 50%;
        display: inline-block;
        background-color: #999;
        margin-right: 5px;
      }
    }
  }
}

.descriptions {
  min-height: 80px;
  display: flex;

  .descriptionsTitle {
    padding: 0 22px;
    min-height: 100px;
    width: 200px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    .text {
      text-align: center;
    }
    strong {
      line-height: 14px;
    }
    span {
      line-height: 14px;
      display: inline-block;
      text-align: center;
      width: 100%;
    }
  }

  .descriptionsContent {
    flex: 1;
    padding-left: 20px;
    display: flex;
    align-items: center;
    justify-content: left;
    box-sizing: border-box;
  }
}
.popupHeader {
  display: flex;
  align-items: center;
  color: #fff;
  margin-bottom: 22px;
  .value {
    margin-left: 42px;
  }
}
</style>
